'use strict';

/**
 * An embedded value is simply a StoragePayload with a Reference
 * address, and any optional storage metadata. It contains all the
 * information needed for a reducer to store it.
 *
 * Embedded values can contain each-other recursively by way of their
 * storage payload.
 *
 * Do not instantiate this class directly - use the `embedded()`
 * helper instead.
 *
 * @class EmbeddedValue
 * @property {Reference} reference address of this value
 * @property {StoragePayload} storagePayload what to store at the address
 * @property {object} meta additional storage metadata
 */
module.exports = class EmbeddedValue {
  constructor (reference, storagePayload, meta = {}) {
    this.reference = reference;
    this.storagePayload = storagePayload;
    this.meta = meta;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/EmbeddedValue.js